import CreateFanclub from "../../../pages/fanclub/Create";
import {getFanclubWizardRoute} from "./factory/wizard";

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getFanclubWizardRoute(),
        component: CreateFanclub,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;